import { Observable } from '@cdn/state';
import { Formats } from './formats';
import { Locale } from './locale';
import { Missing } from './missing';
import { Translator } from './translator';

interface Specs {
	locale: Locale;
	/** Report catalog problems to the console; on in development */
	loud?: boolean;
	clock?: () => number;
}

/**
 * Localization of the interface: owns the selected language and exposes text, formats and the missing-key
 * report. It changes whenever the language does, which re-renders every consumer.
 */
export class I18n extends Observable {
	#locale: Locale;
	get locale() {
		return this.#locale;
	}

	#missing: Missing;
	get missing() {
		return this.#missing;
	}

	#translator: Translator;
	get translator() {
		return this.#translator;
	}

	#formats: Formats;
	get format() {
		return this.#formats;
	}

	/** UI text of this application's catalogs */
	get t() {
		return this.#translator.text;
	}

	/** Text of the shared contracts catalog: statuses, event summaries and help */
	get term() {
		return this.#translator.term;
	}

	#release: () => void;

	constructor({ locale, loud = false, clock }: Specs) {
		super();
		this.#locale = locale;
		this.#missing = new Missing(loud);
		this.#translator = new Translator(locale, this.#missing);
		this.#formats = new Formats(locale, clock);
		this.#release = locale.subscribe(() => this.changed());
	}

	destroy() {
		this.#release();
		this.#locale.destroy();
	}
}
